import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Project} from 'src/app/core/models/project-pilot.model';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { Message, PrivilegeType, TableData } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { ProjectPilotService } from 'src/app/shared/services/project-pilot.service';
import { ManageProjectComponent } from '../manage-project/manage-project.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {
  public tableData: TableData = { content: [] } as TableData;
  public pageSizes: number[] = [];
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  private context: Context;
  private pageDataKey: string = 't';

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private dataService: DataService,
    private projectPilotService: ProjectPilotService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.pageSizes = this.commonService.getDefaultPageSizes();
    this.tableData = this.commonService.getDefaultPageData(this.pageDataKey);
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.context = this.authService.getContextData();
    if (this.context && this.context?.companyId) {
      this.getProjects();
    }
  }

  private getProjects(clear: boolean = true, pageNumber: number = this.tableData.number - 1): void {
    if (this.context?.companyId) {
      if (clear) {
        this.isLoading = true;
        this.tableData.content = [];
      }
      const pageSize = Number(this.tableData.size || 10); 
      this.projectPilotService.getProjectByPage(pageNumber, pageSize).subscribe({
        next: (tableData: TableData) => {
          this.tableData = {
            ...tableData,
            number: pageNumber + 1 
          };
          this.tableData.size = pageSize;
          this.tableData.content = this.tableData?.content?.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }
  

  // private getProjects(clear: boolean = true) {
  //   if (this.context?.companyId) {
  //     if (clear) {
  //       this.isLoading = true;
  //       this.tableData.content = [];
  //     }
  //     this.projectPilotService.getProjectByPage(this.tableData.number - 1,this.tableData.size,).subscribe({
  //       next: (tableData: TableData) => {
  //         this.tableData = tableData;
  //         this.tableData.content = this.tableData?.content?.sort((a, b) => a.id - b.id);
  //         this.isLoading = false;
  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.isLoading = false;
  //       }
  //     });
  //   } else {
  //     this.isLoading = false;
  //   }
  // }

  public deleteProject(project: Project, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.title = "Project deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete project";
    modalRef.componentInstance.message = project.name;
    modalRef.componentInstance.label = 'project';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        project.isDeleteInProgress = true;
        this.projectPilotService.deleteProject(project.id).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, message.text);
              this.tableData?.content.splice(index, 1);
              this.getProjects(false);
              project.isDeleteInProgress = false;
            } else {
              this.commonService.setToastr(500, message.text);
              project.isDeleteInProgress = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            project.isDeleteInProgress = false;
          },
        });
      }
    });
  }

  public upsertProject(project?: Project) {
    if (!this.privilege.canEdit) return;
    this.router.navigate(['/project-pilot/manage-project'],
      { queryParams: {pId: project?.id } }
    );
  }

  public toggleProjectStatus(project: Project) {
    if (!this.privilege.canEdit) {
      setTimeout(() => { project.disabled = !project.disabled }, 0);
      return;
    }
    this.projectPilotService.toggleProjectStatus(project).subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          this.commonService.setToastr(200, `Project ${project.name} is now ${project.disabled ? 'disabled' : 'enabled'}!`);
        }
      },
      error: (error: HttpErrorResponse) => {
        project.isDeleteInProgress = false;
      },
    });
  }

  public loadTableData(e: any) {
    this.tableData.size = +this.tableData.size;
    this.tableData.number = 1;
    this.commonService.storePageData(this.pageDataKey, this.tableData.size, this.tableData.number);
    this.getProjects(true);
  }

  // public loadTableData(e) {
  //   const newPage = e ?? this.tableData.number;
  //   if (newPage === this.tableData.number && e !== null) return;
  //   this.tableData.number = newPage;
  //   this.commonService.storePageData(this.pageDataKey, this.tableData.size, this.tableData.number);
  //   this.getProjects(false);
  // }

  public onPageChange(newPage: number): void {
    this.tableData.number = newPage; 
    const pageNumber = newPage - 1;  
    this.getProjects(false, pageNumber);
  }

  public getBadgeClassForStatus(status: string): string {
    switch (status?.toUpperCase()) {
      case 'NOT_STARTED':
        return 'badge bg-secondary text-white rounded-pill';
      case 'IN_PROGRESS':
        return 'badge bg-primary text-white rounded-pill';
      case 'COMPLETED':
        return 'badge bg-success text-white rounded-pill';
      case 'ON_HOLD':
        return 'badge bg-warning text-dark rounded-pill';
      case 'CANCELLED':
        return 'badge bg-danger text-white rounded-pill';
      default:
        return 'badge bg-light text-dark rounded-pill';
    }
  }
  
  public formatStatus(label: string): string {
    return label
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  public getBadgeClassForPriority(priority: string): string {
    switch (priority?.toUpperCase()) {
      case 'LOW':
        return 'badge bg-secondary text-white rounded-pill';
      case 'MEDIUM':
        return 'badge bg-warning text-dark rounded-pill';
      case 'HIGH':
        return 'badge bg-primary text-white rounded-pill';
      case 'CRITICAL':
        return 'badge bg-danger text-white rounded-pill';
      default:
        return 'badge bg-success text-white rounded-pill';
    }
  }

  public formatPriority(label: string): string {
    return label
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }
}
